import React from 'react'
import PropTypes from 'prop-types'

const MenuIcon = props => {
  return (
    <button
      className={`hamburger-menu ${props.mobile ? '' : 'is-hidden'}`}
      onClick={() => props.setOpen(!props.open)}
    >
      <svg
        viewBox="0 0 40 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="toggle menu"
        className="navigation-icon mod-menu"
      >
        <title>Menu</title>
        <rect width="40" height="4" fill="white" />
        <rect y="10" width="40" height="4" fill="white" />
        <rect y="20" width="40" height="4" fill="white" />
      </svg>
    </button>
  )
}

Window.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  mobile: PropTypes.bool
}

export default MenuIcon
